import { MedicalServices } from './MedicalServices';

export const MedicalServicesEmonet = () => {
  return <MedicalServices contextType="STANDARD" />;
};

export default MedicalServicesEmonet;
